export const fetchAPI = async (endpoint, options = {}) => {
  const baseURL = process.env.NEXT_PUBLIC_API_URL;
  const defaultHeaders = {
    Accept: "*/*",
    "Content-Type": "application/json",
    Authorization: process.env.NEXT_PUBLIC_STRAPI_KEY,
  };

  try {
    const response = await fetch(`${baseURL}${endpoint}`, {
      ...options,
      next: {
        revalidate: parseInt(process.env.NEXT_PUBLIC_REVALIDATE_TIME || 60), // Default 10 minutes, can be overridden
        // revalidate: options.revalidate || 600, // Default 10 minutes, can be overridden
      },
      headers: {
        ...defaultHeaders,
        ...options.headers,
      },
    });

    if (!response.ok) {
      console.error(
        `API call failed for "${endpoint}" with status: ${response.status} ${response.statusText}`,
      );
      return null;
    }

    return response.json();
  } catch (error) {
    console.error("Fetch API error:", error);
    return null;
  }
};
